// extracted by mini-css-extract-plugin
var _1 = "DefaultElementPreview_item__e5f62";
var _2 = "DefaultElementPreview_matchingElement__c7c37";
var _3 = "DefaultElementPreview_row__03c8f";
var _4 = "DefaultElementPreview_text__c2f90";
export { _1 as "item", _2 as "matchingElement", _3 as "row", _4 as "text" }
